import AnniGiftForm from './AnniGiftForm';
import AnniGiftGraph from './AnniGiftGraph';
import AnniGiftList from './AnniGiftList';
import {
  AnniProjectDetailProps,
  AnniProjectMessage,
  getAnniEndDDay,
  getAnniGoalAmountPer,
} from '../AnniProjectPopupInterface';
import {
  AnniversaryProjectControllerService,
  anniversaryProjectVo,
} from '@/__generated__/FrontApi';
import ImgNodata from '@/assets/img/anniversary/img_nodata.png';
import IconMsg from '@/assets/img/icons/ico_letter_blue@2x.png';
import IconMsg2 from '@/assets/img/icons/ico_msg@2x.png';
import inputTextImg2 from '@/assets/img/involve/box_shape_blue.jpg';
import inputTextImg from '@/assets/img/involve/box_shape_gray.jpg';
import Image from '@/components/Image';
import InputTextarea from '@/components/Input/InputTextarea';
import { breakpoint } from '@/helpers/BreakpointHelper';
import moment from 'moment';
import React, { FC, useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';

const ContentSection = styled.div`
  margin: 30px 0;
  max-width: 768px;
  display: inline-block;
  text-align: initial;
  width: 100%;

  &.no-data {
    text-align: center;
  }
  .top-dec {
    margin-top: 32px;
  }

  .show-msg {
    margin-top: 35px;
  }

  ${breakpoint(`mobile`)} {
    padding: 32px 0 40px;
  }
`;

const SupportFlex = styled.div`
  display: flex;
  justify-content: space-between;

  ${breakpoint(`mobile`)} {
    flex-direction: column;
  }
`;

const H3 = styled.h3`
  font-size: 22px;
  color: #0cabe2;
  font-weight: bold;
  letter-spacing: -0.88px;
  margin-bottom: 15px;

  i {
    font-family: 'Noto Sans CJK KR';
    font-style: normal;
    font-weight: normal;
    vertical-align: middle;
    margin-left: 8px;
    letter-spacing: 0;

    &.ico-goal-count {
      color: #999;
      font-size: 12px;
      background: #f5f5f5;
      border-radius: 10px;
      line-height: 20px;
      padding: 0 11px;
      display: inline-block;
    }
  }
  ${breakpoint(`mobile`)} {
    font-size: 16px;
    i {
      &.ico-goal-count {
        font-size: 10px;
      }
    }
  }
`;

/* <Text> 안에 서로 다른 3개의 속성에 따른 list style값 */
const Text = styled.span<{
  listStyle?: boolean;
  titStyle?: boolean;
  titStyle2?: boolean;
}>`
  display: inline-block;
  position: relative;
  line-height: 1.7;
  ${({ listStyle }) => {
    if (listStyle) {
      return `
      &::before {
        content: '';
        display: inline-block;
        width: 5px;
        height: 5px;
        background: #1cabe2;
        border-radius: 100%;
        vertical-align: middle;
        margin: -4px 10px 0 4px;

        ${breakpoint(`mobile`)} {
          width: 4px;
          height: 4px;
        }
      }
      `;
    }
    return ``;
  }}
  ${({ titStyle }) => {
    if (titStyle) {
      return `
      &::before {
        content: '';
        display: inline-block;
        width: 18px;
        height: 13px;
        background: url(${IconMsg}) no-repeat;
        background-size: contain;
        vertical-align: middle;
        margin: -2px 10px 0 2px;
      }
        `;
    }
    return ``;
  }}
  ${({ titStyle2 }) => {
    if (titStyle2) {
      return `
      &::before {
        content: '';
        display: inline-block;
        width: 18px;
        height: 15px;
        background: url(${IconMsg2}) no-repeat;
        background-size: contain;
        vertical-align: middle;
        margin: -2px 10px 0 2px;
      }
        `;
    }
    return ``;
  }}
`;

const ColLeft = styled.div`
  width: calc(50% - 15px);
  picture {
    position: relative;
    width: 100%;
    display: block;

    &::after {
      display: block;
      content: '';
      padding-bottom: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  ${breakpoint(`mobile`)} {
    width: 100%;
    margin-bottom: 15px;
  }
`;

const MsgBox = styled.div`
  background: #f8f9fa;
  padding: 13px 15px 30px;
  ${Text} {
    display: block;
    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: #bebfc1;
      margin-top: 5px;
    }
  }
  p {
    line-height: 1.625;
    padding-top: 15px;
    min-height: 244px;
    max-height: 244px;
    overflow-y: auto;
    white-space: pre-wrap;
    &::-webkit-scrollbar {
      width: 4px;
      background: #e2e3e3;
    }
    &::-webkit-scrollbar-thumb {
      background: #1cabe2;
    }

    ${breakpoint(`mobile`)} {
      min-height: auto;
      max-height: 171px;
    }
  }
  ${breakpoint(`mobile`)} {
    padding: 15px 15px 20px;
  }
`;

const ColRight = styled.div`
  width: calc(50% - 15px);
  ul li {
    i {
      font-family: 'Noto Sans CJK KR';
      font-style: normal;

      &.ico-dday {
        color: #1cabe2;
        font-size: 12px;
        background: #e8f6fc;
        border-radius: 5px;
        line-height: 20px;
        padding: 0 12px;
        margin-left: 7px;
        letter-spacing: 0;
      }
    }
    ${Text} {
      display: block;

      .ico-goal-over {
        position: absolute;
        right: 0;
        bottom: -5px;
        color: #1cabe2;
        font-size: 14px;
        font-weight: normal;
        strong {
          font-size: 18px;
        }
      }
    }

    &:not(:last-child) ${Text} {
      display: inline-block;
      width: 120px;
      ${breakpoint(`mobile`)} {
        width: 111px;
      }
    }
  }

  .textarea_bgbox {
    position: relative;
    margin: 10px 0 17px;

    &::after {
      content: '';
      display: block;
      width: 43px;
      height: 36px;
      background: url(${inputTextImg}) no-repeat;
      background-size: contain;
      position: absolute;
      top: 0;
      right: 0;
    }
    &:focus-within {
      &::after {
        background: url(${inputTextImg2}) no-repeat;
      }
    }
    ${InputTextarea} {
      height: 232px;
      ${breakpoint(`mobile`)} {
        height: 260px;
      }
    }
  }

  ${breakpoint(`mobile`)} {
    width: 100%;
  }
`;

const AnniProjectView: FC<AnniProjectDetailProps> = ({ ...props }) => {
  const defaultTitle = '';
  const [items, setItems] = useState<any>();
  const [isLoadData, setIsLoadData] = useState(false);
  const [anniImage, setAnniImage] = useState('');

  const loadItems = useCallback(async () => {
    props.setPopupTitle(defaultTitle);
    setIsLoadData(false);
    setItems(null);

    AnniversaryProjectControllerService.selectAnniversaryProjectDetailGet({
      indexNumber: props.id,
    })
      .then(({ data, resultCode }) => {
        const resData = data as anniversaryProjectVo;
        setItems(resData);
        if (resultCode === `success`) {
          props.setPopupTitle(resData?.aprjtName || defaultTitle);
          setAnniImage(
            resData?.aprjtAttImg && resData?.imgAttImgTn
              ? resData?.imgAttImgTn
              : ImgNodata,
          );
        }
        setIsLoadData(true);
      })
      .catch(() => {
        setIsLoadData(false);
      });
  }, [props]);

  useEffect(() => {
    setAnniImage(ImgNodata);
    if (props.id === 0) {
      setIsLoadData(false);
    } else {
      loadItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  if (isLoadData === false)
    return (
      <ContentSection className="no-data">
        {AnniProjectMessage.PageLoading}
      </ContentSection>
    );

  if (!items) {
    props.setPopupTitle(AnniProjectMessage.DefaultTitle);
    return (
      <ContentSection className="no-data">
        {AnniProjectMessage.PageNotFound}
      </ContentSection>
    );
  }

  /* ********************* 정상적인 접근일 경우 페이지 랜더링 ****************** */

  return (
    <ContentSection>
      <SupportFlex>
        <ColLeft>
          <Image
            pcSrc={anniImage}
            mobileSrc={anniImage}
            onError={() => {
              setAnniImage(ImgNodata);
            }}
          />
          <MsgBox>
            <Text titStyle2>
              <b>메시지</b>
            </Text>
            <p>{items?.aprjtMessage}</p>
          </MsgBox>
        </ColLeft>
        <ColRight>
          <H3>
            후원하기
            <i className="ico-goal-count">
              {(items.giftTotalAmountInfo.totalCount || 0)?.toLocaleString()}명
              참여
            </i>
          </H3>
          <ul>
            <li>
              <Text listStyle>
                <b>기념일 종류</b>
              </Text>
              <span>{items?.anniTypeName}</span>
            </li>
            <li>
              <Text listStyle>
                <b>후원자 기념일</b>
              </Text>
              <span>
                {items?.anniDate
                  ? moment(items.anniDate).format('YY.MM.DD')
                  : ''}
              </span>
            </li>
            <li>
              <Text listStyle>
                <b>목표기간</b>
              </Text>
              <span>
                {items?.goalStartDate
                  ? moment(items.goalStartDate).format('YY.MM.DD')
                  : ''}
                &nbsp;~&nbsp;
                {items?.goalEndDate
                  ? moment(items.goalEndDate).format('YY.MM.DD')
                  : ''}
                {items.displayStateTypeCode === '3' &&
                getAnniEndDDay(items.goalEndDate || '') > 0 ? (
                  <i className="ico-dday">
                    D-{getAnniEndDDay(items.goalEndDate || '')}
                  </i>
                ) : (
                  <></>
                )}
              </span>
            </li>
            <li>
              <Text listStyle>
                <b>목표금액 대비 후원금액</b>
                {getAnniGoalAmountPer(
                  items.goalAmount || 0,
                  items?.giftTotalAmountInfo?.totalAmount || 0,
                ) > 100 ? (
                  <i className="ico-goal-over">
                    <strong>
                      {getAnniGoalAmountPer(
                        items.goalAmount || 0,
                        items?.giftTotalAmountInfo?.totalAmount || 0,
                      )?.toLocaleString()}
                    </strong>
                    % 달성
                  </i>
                ) : (
                  <></>
                )}
              </Text>
              <AnniGiftGraph
                total={items?.giftTotalAmountInfo?.totalAmount || 0}
                goal={items?.goalAmount || 0}
              />
            </li>
          </ul>
          {/** 기부참여 폼 */}
          <AnniGiftForm
            onRequestClose={() => {
              props.onRequestClose();
            }}
            datas={items}
          />
        </ColRight>
      </SupportFlex>
      {/** 기부참여자 목록 */}
      <AnniGiftList action={props.action} datas={items} />
    </ContentSection>
  );
};

export default AnniProjectView;
